import { Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { DataGrid } from '@mui/x-data-grid'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const CategoryMaster = () => {
    const [formState, setFormState] = useState({
        categoryCode: "",
        categoryName: "",
    });
    const [isActive, setIsActive] = useState(true);
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    });
    const [CategoryData, setCategoryData] = useState([]);
    const [EditID, setEditID] = useState(null);
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);

    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Category Master", "SubTab")?.editAccess

    useEffect(() => {
        getCategoryMaster();
    }, []);

    const getCategoryMaster = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.AYURVEDA_CATEGORY_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setCategoryData(response?.data?.data || [])
                    }
                    setisloader(false)
                }).catch(e => {
                    setisloader(false)
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const AddCategoryMaster = () => {
        try {
            if (!formState?.categoryName) {
                return errorMessage('Please Enter Category Name');
            }
            let data = {
                category_name: formState?.categoryName,
                is_active: isActive,
            }
            setisloader(true)
            let apiCall;
            if (EditID) {
                apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_CATEGORY_MASTER);
            } else {
                apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_CATEGORY_MASTER);
            }
            apiCall
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setFormState({
                            categoryCode: "",
                            categoryName: "",
                        });
                        setIsActive(true)
                        setEditID(null)
                        getCategoryMaster()
                    }
                    setisloader(false)
                }).catch(e => {
                    setisloader(false)
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteCategoryMaster = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || [])
            RestAPIService.delete(Serviceurls.AYURVEDA_CATEGORY_MASTER + `?ids=${ID}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getCategoryMaster()
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false)
                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: msg,
        })
    }

    const successMessage = (msg) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: msg,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const tableView = () => {
        const grpDelete = () => setisDelete(true)

        const gridToolBar = () => (
            <Box>
                <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
            </Box>
        )

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = CategoryData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        CategoryData?.forEach((element, index) => element.sno = index + 1)

        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.05, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.row.sno}</Typography>)
            },
            {
                field: 'category_code', headerName: 'Category Code', flex: 0.2,
                renderCell: (params) => (<Box>{params?.row?.category_code || '-'}</Box>)
            },
            {
                field: 'category_name', headerName: 'Category Name', flex: 0.4,
                renderCell: (params) => (params.row.category_name ? params.row.category_name?.length > 32 ?
                    <Tooltip placement="top" title={params.row.category_name}><Typography fontSize={'0.9vw'}>{params.row.category_name?.slice(0, 30) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.category_name}</Typography> : '-')
            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.1,
                renderCell: (params) => (<Box>{params?.row?.is_active ? "Active" : "Inactive"}</Box>)
            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <CommonEditButton size="1.5vw" onClick={() => {
                            setFormState({
                                categoryCode: params.row.category_code || '',
                                categoryName: params.row.category_name || '',
                            });
                            setEditID(params.row.id);
                            setIsActive(params.row.is_active || false);
                        }} />
                    </Stack>)
            }] : [])
        ]

        return (
            <Box sx={{ height: '64vh' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={CategoryData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    loading={isloader}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                />
            </Box>
        )
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ height: '13vh', width: '93vw', backgroundColor: "white", padding: "0.5vw" }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <TextField
                        size="small"
                        name="categoryCode"
                        value={formState?.categoryCode}
                        disabled
                        sx={{ width: "15vw", marginRight: "1vw" }}
                        label="Category Code"
                        variant="outlined"
                    />
                    <TextField
                        size="small"
                        name="categoryName"
                        inputProps={{maxlength: 50}}
                        value={formState?.categoryName}
                        sx={{ width: "20vw", marginRight: "1vw" }}
                        label="Category Name *"
                        variant="outlined"
                        onChange={(e) => setFormState({ ...formState, categoryName: e.target.value })}
                    />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
                    <Box>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} disabled={!EditID} size="small" />} label="Active" />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                        <Button size="small" variant="outlined" sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
                            onClick={() => {
                                setFormState({ categoryCode: "", categoryName: "" });
                                setIsActive(true)
                                setEditID(null)
                            }}>Clear</Button>
                        <Button size="small" variant="contained" sx={{ textTransform: 'capitalize', width: '7vw' }}
                            onClick={() => AddCategoryMaster()}>{EditID ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ height: '64vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>

            {message.isErrorMsg &&
                <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose} />
            }
            {message.successMsg &&
                <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose} />
            }
            {isDelete &&
                <DeletePopup
                    DeletTitle="Are you sure you want to delete this item?"
                    DeleteNotify="This action cannot be undone."
                    deleteAlertPopupClose={() => setisDelete(false)}
                    removeData={deleteCategoryMaster}
                    ButtonText="Yes"
                />
            }
            <Loader loaderOpen={isloader} />
        </Box>
    )
}

export default CategoryMaster;
